export default __webpack_public_path__ + "media/admin-tools-vector.29a4fe9392f386a7f0f6725d4b63deb9.svg";